import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import GetAppIcon from '@mui/icons-material/GetApp';
import style from './style';
import { globalStyles } from "shared/constants";
import { noop } from "shared/constants";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import Divider from "@mui/material/Divider";



const DownloadView = ({
  downloadDialog = {},
  isTemplateDownloaded = false,
  handleDownloadClick = noop,
  handleDownlodDialogClose = noop,
}) => {

  return (
    <>
      <Paper elevation={0} sx={style.paper}>
        <Box sx={style.wrapper}>
          <Box>
            <Typography variant="body1" sx={style.title}>Excel Sheet</Typography>
            <Typography variant="body2">1. Download the Excel Sheet.</Typography>
            <Typography variant="body2">2. Fill in the Sheet with your addresses.</Typography>
            <Typography variant="body2">3. Save the edited Sheet to your computer.</Typography>
          </Box>
          <Box>
            <Button
              variant="contained"
              startIcon={<GetAppIcon />}
              // disabled={isTemplateDownloaded}
              onClick={handleDownloadClick}
            >
              Download
            </Button>
          </Box>
        </Box>
      </Paper>
      {downloadDialog.open && (
        <Dialog
          disableEscapeKeyDown
          open={downloadDialog.open}
          onClose={handleDownlodDialogClose}
          sx={{...style.downloadDialogPaper}}
        >
          <DialogContent>
            <Box
              sx={{
                ...globalStyles.display.flex,
                ...globalStyles.flex.justify.end,
                ...globalStyles.cursor.pointer
              }}
            >
              <CloseIcon onClick={handleDownlodDialogClose} sx={{ ...style.downloadDialogCloseIcon }} />
            </Box>
            <Box
              sx={{
                ...globalStyles.display.flex,
                ...globalStyles.flex.direction.column,
              }}
            >
              <Typography
                variant='h5'
                sx={{ ...globalStyles.text.weight.bold, ...globalStyles.text.color.default}}
              >
                Downloading
              </Typography>
              <LinearProgress
                variant='determinate'
                value={downloadDialog.progress}
                sx={[
                  globalStyles.margin(5, 'Top'),
                  globalStyles.width[100],
                  style.downloadProgressBar,
                ]}
              />
              <Box
                sx={{
                  ...globalStyles.display.flex,
                  ...globalStyles.flex.justify.center,
                  ...globalStyles.width[100],
                  ...globalStyles.margin(4, 'Top'),
                }}
              >
                <Divider sx={{ ...style.divider }} />
                <Button
                  variant="contained"
                  sx={{
                    ...globalStyles.margin(2, 'Top'),
                    ...globalStyles.margin(4, 'Bottom')
                  }}
                  onClick={handleDownlodDialogClose}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default DownloadView;